define([
	"dojo/_base/declare",
	"csi/sessionConstants",
	"csi/table/New",
	"./NewSupplierRequestMixin",
	"Apparel/DesignatedSupplierMixin",
	"Sourcing"
], function (declare, sessionConstants, New, NewSupplierRequestMixin, DesignatedSupplierMixin, Sourcing) {

	return declare([New, NewSupplierRequestMixin, DesignatedSupplierMixin], {

		/**
		 * @override
		 * Set the product and the default requester on create form
		 * @param {ViewWidget} view
		 */
		onCreatePopup(view) {
			this.inherited(arguments);
			this.setSupplierRequestDefaults(view);
		},

		/**
		 * set the product and the default requester on create form
		 * @param {FormWidget} view
		 */
		setSupplierRequestDefaults(view) {
			const parent = this.getParent();
			if (parent && this.productField != "FoodSKUs") {
				view.addFixedValue(parent.$Type + "s", [parent.$URL]);
			}

			const isFDDEnabled = Sourcing.isFDDEnabled(parent, this.m_cache);
			if (isFDDEnabled) {
				//initialize designated supplier factory
				this.initializeDPS(view, "SRSupplierFactories", isFDDEnabled);
			} else {
				// initialize designated supplier
				this.initializeDPS(view, "SRSuppliers");
			}

			view.addFixedValue("RequestType", this.fixedType);
			view.addDefaultValue("Requester", sessionConstants.userUrl);
		}
	});
});
